import { TypeOfSupportEnum } from "utils/enums/TypeOfSupportEnum";
import { DataFormat } from "utils/format/DataFormat";

export class BaseSupportFeatureRequestModel {
  isdnOrIccid?: string;
  typeOfSupport?: TypeOfSupportEnum;
  service?: string;

  public removeUnknowValue<T extends BaseSupportFeatureRequestModel>(data: T) {
    return DataFormat.removeUndefined(
      data as unknown as Record<string, unknown>
    );
  }
}
